module.exports = __webpack_public_path__ + "img/add-frame.6dd9f1f2.svg";